import { faCheck, faCookie, faCookieBite } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import isDevelopment from "consumerhouse-shared";
import { useLanguage } from "../useLanguage";
import Button from "./Button";
import { LinkButton } from "./LinkButton";

const Container = styled.div`
    position: fixed;
    max-width: 800px;
    border-radius: 1em 1em 0 0;
    bottom: 0;
    left: calc(50% - 400px);
    position: fixed;
    background: #3a3a3c;
    padding: 1.2em;
    color: white;
    box-shadow: 0px 5px 10px #0005;
    display: flex;
    align-items: center;
    font-size: 0.95em;
    z-index: 30;

    @media only screen and (max-width: 800px) {
        left: 0;
        width: 100%;
        max-width: 100%;
    }
`;

const CookieIcon = styled.div`
    font-size: 2em;
    margin: 0 0.5em 0 0;
`;

export function CookieMessage() {
    const [visible, setVisible] = useState(!localStorage.getItem("cookie"));
    const language = useLanguage();

    function accept() {
        localStorage.setItem("cookie", "true");
        setVisible(false);
    }

    if (!visible) return null;

    return (
        <Container>
            <CookieIcon>
                <FontAwesomeIcon icon={faCookieBite} />
            </CookieIcon>
            <p>
                {language("cookie-info")}{" "}
                <Link to="/terms-and-conditions">
                    <LinkButton onClick={accept} style={{ color: "#aabbfd" }}>
                        {language("cookie-terms")}
                    </LinkButton>
                </Link>
                .
            </p>
            <Button style={{ flexShrink: 0, margin: "0 0 0 1em" }} icon={faCheck} color="#56a44f" onClick={accept}>
                {language("cookie-ok")}
            </Button>
        </Container>
    );
}
